// extracted by mini-css-extract-plugin
export default {"review":"styles_review__7M9sb","header":"styles_header__2TXIu","avatar":"styles_avatar__lTSw-"};